import React from "react"
import Link from "gatsby-link"
import { Helmet } from "react-helmet"
import Header from "./Header/Header.js"
import Footer from "./Footer/Footer.js"
import Banner from "../components/Banner"
import * as PropTypes from "prop-types"

import style from "./index.module.css"

const propTypes = {
  children: PropTypes.func.isRequired,
}

class DefaultLayout extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <Header />
        <div id="contentContainer" className={style.content}>
          {this.props.children()}
        </div>
        <Footer />
      </div>
    )
  }
}

DefaultLayout.propTypes = propTypes

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js